<template>
<v-list-tile @click="dialog = true">
  <v-list-tile-title>
    Settings
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-toolbar dark color="green">
        <v-toolbar-title>Settings</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="dialog = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <!-- <v-btn flat slot="activator">Settings</v-btn> -->
      <v-card>
        <v-card-text>
          <v-container grid-list-md fluid>
            <v-tabs fixed-tabs hide-slider icons-and-text>
              <v-tab class="active" href="#tab-1">
                Profile
                <v-icon>account_box</v-icon>
              </v-tab>

              <v-tab href="#tab-2">
                Account
                <v-icon>account_box</v-icon>
              </v-tab>

              <v-tab href="#tab-3">
                Projects
                <v-icon>library_books</v-icon>
              </v-tab>
              <v-tab-item v-model="e1" value="tab-1" class="mt-3">
                <div class="tile">
                  <div class="tile-content text-left">
                    <div class="tile-subtitle">
                      <v-text-field label="Display Name" color="green lighten-2" class="form-input" v-model="profileDetails.newName" type="text" :placeholder="user.displayName"></v-text-field>
                    </div>
                  </div>
                </div>
                <div class="tile">
                  <div class="tile-content text-left">
                    <div class="tile-subtitle">
                      <!-- <v-text-field color="green lighten-2" class="form-input form-inline" @change="handleFile($event);" style="width: 300px;" accept="image/*" type="file" name="" id=""></v-text-field> -->
                      <v-text-field color="green lighten-2" label="Upload a profile picture" @click='pickFile' v-model='imageName' prepend-icon='attach_file'></v-text-field>
                      <input style="display: none" @change="handleFile($event);" accept="image/*" ref="image" type="file" name="" id="">
                    </div>
                  </div>
                </div>
                <div class="tile">
                  <div class="tile-content text-left">
                    <div class="tile-subtitle">
                      <v-textarea color="green lighten-2" label="About you" @keydown.ctrl.enter="saveChanges" name="bio" cols="53" rows="3" style="resize: none;" v-model="profileDetails.newBio" :placeholder="userBio"></v-textarea>
                    </div>
                  </div>
                </div>
              </v-tab-item>
              <v-tab-item value="tab-2" class="mt-3">
                <div class="tile">
                  <div class="tile-content text-left">
                    <div class="tile-subtitle">
                      <v-text-field color="green lighten-2" label="Email" class="form-input" :value="user.email" type="text" placeholder="New Email"></v-text-field>
                    </div>
                  </div>
                </div>
                <div class="tile">
                  <div class="tile-content text-left">
                    <div class="tile-subtitle">
                      <div class="form-group">
                        <v-text-field color="green lighten-2" label="Confirm Current Password" class="form-input" type="password" id="currentPassword" placeholder="Old Password"></v-text-field>
                        <v-text-field label="Enter New Password" color="green lighten-2" class="form-input" type="password" id="newPassword" placeholder="New Password"></v-text-field>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <div class="tile">
                      <div class="tile-content text-left">
                        <div class="tile-title text-bold">Delete Account</div>
                        <div class="tile-subtitle">
                          <div class="form-group">
                            <label for="deleteBtn" class="form-label text-warning">This cannot be undone!</label>
                            <v-btn flat color="red" id="deleteBtn">
                              Delete Account
                            </v-btn>
                          </div>
                        </div>
                      </div>
                    </div> -->
              </v-tab-item>
              <v-tab-item value="tab-3" class="mt-3">
                <table class="table table-striped table-hover">
                  <thead>
                    <tr>
                      <th>Group Name</th>
                      <th>Members</th>
                      <th class="text-center">Leave Group</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(group, index) in groupList" :key="index">
                      <td>{{ group.projectTitle }}</td>
                      <td>{{ group.membersLength }}</td>
                      <td>
                        <v-btn small flat @click="leaveGroup(group.groupID);" class="btn btn-error btn-block">
                          <v-icon>close</v-icon>
                        </v-btn>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </v-tab-item>
            </v-tabs>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn color="green darken-1" flat @click="dialog = false">Close</v-btn>
          <v-btn color="green darken-1" flat @click="saveChanges">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-list-tile-title>
</v-list-tile>
</template>

<script>
import {
  getUserData,
  getUserGroups
} from "@/scripts/userFuncs";
import {
  FirebaseConsts,
  Storage,
  db
} from "@/firebaseConfig";

let picRef = Storage.ref();

export default {
  name: "ProfileSettings",
  props: {
    user: Object,
    photoURL: String
  },
  data() {
    return {
      e1: 'tab-1',
      dialog: false,
      activeTab: 1,
      profileDetails: {
        newName: "",
        newPhoto: null,
        newBio: ""
      },
      groupList: [],
      userBio: "",
      imageName: ''
    };
  },
  beforeMount() {
    // Load the user's description from firestore
    getUserData(this.user.uid)
      .then(user => {
        this.userBio = user.description;
      })
      .catch(error => {
        console.log("ProfileSettings: " + error);
      });

    this.loadGroups();

    // db.collection("projects").where();
  },
  watch: {
    activeTab(newVal, oldVal) {
      if (newVal === 3) {
        // console.log("reloading groups");
        this.loadGroups();
      }
    }
  },
  methods: {
    loadGroups() {
      getUserGroups(this.user.uid)
        .then(groupList => {
          this.groupList = groupList;
        })
        .catch(error => {
          console.log(error);
        });
    },
    leaveGroup(id) {
      // Remove the user from members list of specific study group
      db.collection("projects")
        .doc(id)
        .update({
          members: FirebaseConsts.firestore.FieldValue.arrayRemove(
            this.$store.getters.uid
          )
        });
      this.loadGroups();
    },
    saveChanges() {
      if (this.activeTab === 1) {
        if (
          this.profileDetails.newName !== this.user.displayName &&
          this.profileDetails.newName !== ""
        ) {
          this.user.updateProfile({
            displayName: this.profileDetails.newName
          });
        }

        if (this.profileDetails.newPhoto !== null) {
          // Set metadata for image
          var metadata = {
            contentType: "image/jpeg"
          };

          let path = "profile-pictures/" + this.user.uid;

          // Upload new picture
          picRef
            .child(path)
            .put(this.profileDetails.newPhoto, metadata)
            .then(() => {
              picRef
                .child(path)
                .getDownloadURL()
                .then(url => {
                  this.user.updateProfile({
                    photoURL: url
                  });

                  db.collection("users")
                    .doc(this.user.uid)
                    .update({
                      photoURL: url
                    });
                });
            });
        }

        // Create new profile bio in firestore
        if (this.profileDetails.newBio !== "") {
          db.collection("users")
            .doc(this.user.uid)
            .update({
              description: this.profileDetails.newBio
            });
        }

        //this.$emit("closeSettings");
        this.dialog = false;
      }
    },
    handleFile(event) {
      this.profileDetails.newPhoto = event.target.files[0];
    },
    pickFile() {
      this.$refs.image.click()
    },

    onFilePicked(e) {
      const files = e.target.files
      if (files[0] !== undefined) {
        this.profileDetails.newPhoto = e.target.files[0];
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-container {
    border-radius: 10px;
}

.tab-item {
    cursor: pointer;
}

.tile-title {
    padding: 5px;
}
.v-tabs__item--active {
    color: #81c784;
}
</style>



// WEBPACK FOOTER //
// src/components/User/ProfileSettings.vue